<template>
  <div>
    <div v-if="mode === 'edit'">
      <!-- <pre>{{ question.ansData }}</pre> -->

      <ul>
        <li class="each-choice" :key="ii" v-for="(samc, ii) in question.ansData.saMC">
          <div class="choice">
            Choice {{ samc.label }}
          </div>
          <div>
            <input type="checkbox" @input="checkOne(samc, question.ansData.saMC)" v-model="samc.isRight" :id="`samc${question._id}_${ii}`" /> <label :for="`samc${question._id}_${ii}`">Is a correct answer?</label>
          </div>
          <div v-if="samc">
            <LatexEdit ref="latexedit" :target="samc" @setTarget="(v) => { $emit('setTarget', v) }"  :init="samc.latex" @inserted="() => {}" @view="(v) => { view = v; $emit('view', v); $emit('saveTo', { obj: samc, key: 'latex' }); }" @text="(v) => { samc.latex = v }"></LatexEdit>
            <!-- <Latex :placeholder="' '" :latex="samc.latex" /> -->
          </div>
          <div v-if="samc">
            <!-- <p>Explanation for this choice, i.e.) why is this right / wrong</p> -->
            <!-- <LatexEdit ref="latexedit" :target="samc" @setTarget="(v) => { $emit('setTarget', v) }"  :init="samc.explain" @inserted="() => {}" @view="(v) => { view = v; $emit('view', v); $emit('saveTo', { obj: samc, key: 'explain' }); }" @text="(v) => { samc.explain = v }"></LatexEdit> -->
            <!-- <Latex :placeholder="' '" :latex="samc.latex" /> -->
          </div>
          <div v-if="ii >= 2 && ii === question.ansData.saMC.length - 1">
            <MyButton type="danger" @click="QS.removeMC(question.ansData.saMC, samc, ii)">Remove Choice</MyButton>
          </div>
        </li>
        <li v-if="question.ansData.saMC.length < 26">
          <MyButton type="primary" @click="QS.addMC(question.ansData.saMC)">Add a Choice</MyButton>
        </li>
      </ul>
      <LatexEdit ref="latexedit" :target="question.ansData" @setTarget="(v) => { $emit('setTarget', v) }"  :init="question.ansData.explain" @inserted="() => {}" @view="(v) => { view = v; $emit('view', v); $emit('saveTo', { obj: question.ansData, key: 'explain' }); }" @text="(v) => { question.ansData.explain = v }"></LatexEdit>

    </div>
    <div v-if="mode === 'view'">
      <ul>
        <li class="each-choice" :key="ii" v-for="(samc, ii) in question.ansData.saMC">
          <div class="choice">
            <input type="checkbox" :disabled="!!submitted" @input="checkOneChoice(samc, question.ansData.saMC)" v-model="samc.checked" :id="`samc_view_${question._id}_${ii}`" /> <label :for="`samc_view_${question._id}_${ii}`">{{ samc.label }}</label>
          </div>
          <div>
            <label :for="`samc_view_${question._id}_${ii}`">
              <Latex ref="latex" :latex="samc.latex"></Latex>
            </label>
          </div>
        </li>
      </ul>
    </div>
    <div v-if="mode === 'mark'">
      <!--  -->
      <ul>
        <li class="each-choice" :key="ii" v-for="(samc, ii) in question.cleanData.saMC">
          <div class="choice">
            <input type="checkbox" :disabled="!!submitted" @input="checkOneChoice(samc, question.cleanData.saMC)" v-model="samc.checked" :id="`samc_view_${question._id}_${ii}`" /> <label :for="`samc_view_${question._id}_${ii}`">{{ samc.label }}</label>
          </div>
          <div>
            <label :for="`samc_view_${question._id}_${ii}`">
              <Latex ref="latex" :latex="samc.latex"></Latex>
            </label>
          </div>
          <!-- <div v-if="!!submitted && samc.explain">
            <Latex ref="latex" :latex="samc.explain"></Latex>
          </div> -->
        </li>
      </ul>
      <div v-if="!!submitted && question.ansData.explain">
        <Latex ref="latex" :latex="question.ansData.explain"></Latex>
      </div>
      <!-- <MyButton @click="$emit('submit', question)">Submit My Answer</MyButton> -->
      <!-- <div style="display: none;">{{ question }}</div> -->
      <!-- <pre>{{ getResult() }}</pre> -->
    </div>
    <div v-if="mode === 'mark'">
      <div>
        <MyButton @click="submitQuestion" :disabled="!!submitted">Submit My Answer</MyButton>
      </div>
      <div v-if="result">
        <h3>
          Mark: <span>{{ result.mark }}</span><span> / </span><span>{{ result.markFull }}</span>
        </h3>
        <div v-if="false">
          <h3>
            Correct Answer: <span>{{ result.correctAns.toString() }}</span>
          </h3>

        </div>
        <!-- <h3 v-if="result.correct.length > 0">
          Your Correct Choices: <span>{{ result.correct.toString() }}</span>
        </h3>
        <h3 v-if="result.incorrect.length > 0">
          Your Incorrect Choices: <span>{{ result.incorrect.toString() }}</span>
        </h3> -->
        <!-- <pre>{{ result }}</pre> -->
      </div>
    </div>
  </div>
</template>

<script>
import { Button } from 'element-ui'
import * as QS from '../compos/question.js'
export default {
  components: {
    MyButton: Button,
    Latex: require('../compos/Latex.vue').default,
    LatexEdit: require('../compos/LatexEdit.vue').default
  },
  props: {
    mode: {
      default: 'edit'
    },
    question: {
      required: true
    }
  },
  data() {
    return {
      QS,
      submitted: false,
      result: false
    }
  },
  watch: {
    question: {
      deep: true,
      handler () {
        if (this.question.ansData && this.question.ansData.saMC && this.mode === 'mark') {
          this.markQuestion()
        }
      }
    }
  },
  methods: {
    markQuestion () {
      this.result = this.getResult()
      this.question.result = this.result
      this.$forceUpdate()
      this.$emit('answered', this.result)
    },
    submitQuestion () {
      this.submitted = true
      this.$emit('submit', this.question)
    },
    getResult () {
      let { question } = this
      let result = QS.markSAMC(question.cleanData.saMC, question.ansData.saMC)
      return result
    },
    checkOne (samc, arr) {
      arr.forEach(ii => ii.isRight = false)
      samc.isRight = true
    },
    checkOneChoice (samc, arr) {
      arr.forEach(ii => ii.checked = false)
      samc.checked = true
    }
  }
}
</script>

<style scoped>
.each-choice{
  margin: 10px;
}
</style>
